// Shared helpers for Orari (read-only / pure).

import dayjsTZ from "../../../utils/dayjs";

export const MS_PER_DAY = 86_400_000;

export const ymOf = (date) => dayjsTZ(date).format("YYYY-MM");

export const ymToLabel = (ym) => dayjsTZ(`${ym}-01`).format("MMMM YYYY");

// Render a week label as DD/MM – DD/MM. When the week spans a month
// boundary, prefer the in-month-clipped range emitted by the backend
// (`weekStartInMonth` / `weekEndInMonth`) so the column header reads
// "29/06 – 30/06" instead of the misleading "29/06 – 05/07".
export const formatWeekLabel = (weekOrMs) => {
  if (typeof weekOrMs === "object" && weekOrMs !== null) {
    const start = weekOrMs.weekStartInMonth || weekOrMs.weekStart;
    const end =
      weekOrMs.weekEndInMonth ||
      (weekOrMs.weekStart
        ? dayjsTZ(weekOrMs.weekStart).add(6, "day").valueOf()
        : null);
    if (!start || !end) return "";
    return `${dayjsTZ(start).format("DD/MM")} – ${dayjsTZ(end).format("DD/MM")}`;
  }
  return `${dayjsTZ(weekOrMs).format("DD/MM")} – ${dayjsTZ(weekOrMs)
    .add(6, "day")
    .format("DD/MM")}`;
};

export const formatDay = (ms) => dayjsTZ(ms).format("ddd DD/MM");

// Map: { [employeeId]: { [weekStart]: assignment } }
export const buildWeekIndex = (weeks) => {
  const idx = new Map();
  for (const w of weeks || []) {
    for (const a of w.assignments || []) {
      if (!a?.employeeId) continue;
      if (!idx.has(a.employeeId)) idx.set(a.employeeId, {});
      idx.get(a.employeeId)[w.weekStart] = a;
    }
  }
  return idx;
};

// Returns the unique union of employees referenced by the schedule's
// assignments, in stable alphabetical order of their full name.
export const employeesOnSchedule = (schedule, allEmployees) => {
  const ids = new Set();
  for (const w of schedule?.weeks || []) {
    for (const a of w?.assignments || []) {
      if (a?.employeeId) ids.add(a.employeeId);
    }
  }
  return (allEmployees || [])
    .filter((e) => ids.has(e.employeeId))
    .sort((a, b) =>
      `${a.employeeFirstName} ${a.employeeLastName}`.localeCompare(
        `${b.employeeFirstName} ${b.employeeLastName}`
      )
    );
};

export const countsByShift = (schedule) => {
  const out = {};
  for (const w of schedule?.weeks || []) {
    for (const a of w?.assignments || []) {
      out[a.shiftId] = (out[a.shiftId] || 0) + 1;
    }
  }
  return out;
};

// For the per-employee summary chip (e.g. "1 javë pasdite / 4").
export const afternoonWeekCountByEmployee = (schedule) => {
  const out = {};
  const afternoonId = schedule?.afternoonShiftIdSnapshot;
  for (const w of schedule?.weeks || []) {
    for (const a of w?.assignments || []) {
      if (a?.shiftId === afternoonId) {
        out[a.employeeId] = (out[a.employeeId] || 0) + 1;
      }
    }
  }
  return out;
};
